import Api from '@/vuex/api'
import { app } from '@/main'
import {
  ASSIGN_SMARTCARD,
  CANCEL_LOT_RELOCATION,
  CHANGE_NAVIGATION,
  CLEAR_ADMIN_REQUEST,
  CLEAR_MODALS,
  CLOSE_MODAL,
  CLOSE_MODAL_FORM,
  CLOSE_FORM,
  CLOSE_LOT,
  COMPLETE_LOT_RELOCATION,
  DELETE_SMARTCARD,
  DELETE_ACCOUNT_MESSAGE,
  DELETE_DASHBOARD_MESSAGE,
  DELETE_CAR_RESTRICTION,
  EXPIRED_SESSION,
  GET_FORM_FIELD,
  GET_FORM_VALUE,
  LOAD_ADMIN_REQUEST,
  LOAD_CARDS,
  LOAD_DASHBOARD,
  LOAD_DASHBOARD_MESSAGES,
  LOAD_FORM,
  LOAD_HELD_CHARGE,
  LOAD_ALL_CAR_RESULTS,
  LOAD_CAR_RESULTS_RATES,
  LOAD_CAR_MESSAGES,
  LOAD_CAR_MESSAGES_TOTAL,
  LOAD_CAR_MESSAGES_TYPE,
  LOAD_CONTRACT_DETAILS,
  LOAD_RESERVATION_NOTES,
  LOAD_RESERVATION_NOTES_TOTAL,
  LOAD_TICKET,
  LOAD_TRAILING_REBATE_PROMO_DETAILS,
  CLOSE_TICKET,
  REOPEN_TICKET,
  DELETE_TICKET,
  ADD_TICKET_PRIORITY,
  REMOVE_TICKET_PRIORITY,
  LOAD_CAR_RESERVATIONS,
  LOAD_CAR_RESERVATIONS_TOTAL,
  LOAD_CAR_RESERVATIONS_COLUMNS,
  LOAD_CAR_RESULTS,
  LOAD_CAR_RESULTS_TOTAL,
  LOAD_CAR_DAMAGES,
  LOAD_CAR_DAMAGES_TOTAL,
  LOAD_CAR_NOTES,
  LOAD_CAR_NOTES_TOTAL,
  LOAD_NOTIFICATIONS,
  LOAD_NOTIFICATIONS_COUNT,
  LOAD_ORGANIZATION,
  LOAD_PETROL_CARDS,
  LOAD_SIDEBAR,
  LOAD_SMART_CARD,
  LOAD_USER_CREDIT_CARDS,
  LOAD_USER_DRIVERS,
  LOAD_USER_DRIVERS_COLUMNS,
  LOAD_USER_DRIVERS_TOTAL,
  LOAD_USER_FILES,
  LOAD_USER_FILES_TOTAL,
  LOAD_USER_FILES_COLUMNS,
  LOAD_USER_LEDGER,
  LOAD_USER_LEDGER_COLUMNS,
  LOAD_USER_NOTES,
  LOAD_USER_NOTES_TOTAL,
  LOAD_USER_RESERVATIONS,
  LOAD_USER_RESERVATIONS_TOTAL,
  LOAD_USER_RESERVATIONS_COLUMNS,
  LOGIN,
  LOGIN_USER,
  MODIFY_FORM_FIELD,
  MODIFY_FORM_VALUE,
  TECH_PUSH_VALET,
  DELETE_VALET,
  OPEN_CONFIRMATION_MODAL,
  OPEN_NOTIFICATION_MODAL,
  OPEN_ERROR_MODAL,
  OPEN_LOT,
  OPEN_MODAL,
  REFRESH_LOGGED_IN_USER,
  REPAIR_DAMAGE,
  RESOLVE_DAMAGE,
  RESOLVE_NOTE,
  RESTORE_SMARTCARD,
  SUBMIT_FORM,
  TOGGLE_SIDEBAR,
  TOGGLE_LOT_OVERNIGHT,
  TOGGLE_LOT_WEEKEND,
  TOGGLE_LOT_ONE_WAY_TRIPS,
  UNASSIGN_SMARTCARD
} from '@/vuex/types'

const api = new Api()
const state = {
  loggedInUser: {
    AccountType: {},
    Contracts: []
  },
  expiredSession: false,
  modals: [],
  forms: [],
  organization: {
    pageTitle: 'My Carshare',
    companyName: 'TechCar',
    companyEmail: '',
    companyLogo: null,
    companyPhone: '',
    homePage: '',
    theme: '',
    name: '',
    stylesheet: false,
    weekendRateStart: '2017-05-23 08:00:00+00',
    weekendRateEnd: '2017-05-22 22:00:00+00',
    overnightRateStart: '2017-05-23 07:00:00+00',
    overnightRateEnd: '2017-05-22 22:00:00+00',
    minimumBooking: 1,
    maximumBooking: 5
  },
  dashboard: {
    reservationOverview: {
      title: "Today's Reservations",
      count: 0,
      columns: [],
      rows: []
    },
    maintenanceOverview: {
      title: 'Cars on Maintenance',
      count: 0,
      columns: [],
      rows: []
    },
    restrictionOverview: {
      title: 'Cars on Restriction',
      count: 0,
      columns: [],
      rows: []
    },
    batteryOverview: {
      title: 'Cars With Battery Alarms',
      count: 0,
      columns: [],
      rows: []
    }
  },
  sidebar: {
    notificationsCount: 0,
    currentSubNav: [],
    currentSubKey: '',
    isOpen: false,
    navigation: {
      followUp: {
        title: 'Follow Up',
        icon: 'exclamation-circle',
        path: '/follow-up',
        badge: 0
      },
      membership: {
        title: 'Membership',
        icon: 'users',
        path: '/membership',
        badge: 0
      },
      fleetManagement: {
        title: 'Fleet',
        icon: 'car',
        path: '/fleet',
        subs: []
      },
      reporting: {
        title: 'Reports',
        icon: 'chart-pie',
        path: '/reports',
        subs: []
      },
      hardware: {
        title: 'Hardware',
        icon: 'microchip',
        path: '/hardware',
        finance: true
      },
      contracts: {
        title: 'Contracts',
        icon: 'paperclip',
        path: '/contracts',
        finance: true
      },
      tickets: {
        title: 'Tickets',
        icon: 'ticket-alt',
        path: '/tickets',
        subs: [],
        badge: 0,
        finance: true
      }
    },
    subNavigation: {
      followUp: [
        { title: 'Notes', icon: 'sticky-note', path: '/follow-up/notes', badge: 0 },
        { title: 'Problems', icon: 'exclamation-circle', path: '/follow-up/problems', badge: 0, finance: true },
        { title: 'Repairs', icon: 'wrench', path: '/follow-up/repairs', badge: 0 },
        { title: 'Resolved Problems', icon: 'check', path: '/follow-up/resolved-problems', badge: 0, finance: true }
      ],
      membership: [
        { title: 'Applications', icon: 'user-plus', path: '/membership/applications', badge: 0 },
        { title: 'Members', icon: 'users', path: '/membership/members', badge: 0 },
        { title: 'Demo Accounts', icon: 'handshake', path: '/membership/demos', badge: 0 },
        { title: 'Plans', icon: 'file-alt', path: '/membership/plans', badge: 0 },
        { title: 'Direct Debit', icon: 'credit-card', path: '/membership/direct-debit', badge: 0, finance: true },
        { title: 'Rates', icon: 'dollar-sign', path: '/membership/rates', badge: 0 },
        { title: 'Smartcards', icon: 'id-card', path: '/membership/smartcards', badge: 0 },
        { title: 'Promotions', icon: 'star', path: '/membership/promotions', badge: 0, finance: true },
        { title: 'Messages', icon: 'comment-alt', path: '/membership/messages', badge: 0, finance: true },
        { title: 'Emails', icon: 'envelope', path: '/membership/emails', badge: 0 }
      ],
      fleetManagement: [
        { title: 'Reservations', icon: 'calendar-alt', path: '/fleet/reservations', badge: 0 },
        { title: 'Maintenance', icon: 'wrench', path: '/fleet/maintenance', badge: 0 },
        { title: 'Valets', icon: 'key', path: '/fleet/valets', badge: 0 },
        { title: 'Restrictions', icon: 'lock', path: '/fleet/restrictions', badge: 0 },
        { title: 'Vehicles', icon: 'car', path: '/fleet/vehicles', badge: 0 },
        { title: 'Lot Relocation', icon: 'compass', path: '/fleet/relocate', badge: 0 },
        { title: 'Lots', icon: 'map-marker-alt', path: '/fleet/lots', badge: 0 },
        { title: 'Tolls', icon: 'upload', path: '/fleet/tolls', badge: 0, finance: true }
      ],
      reporting: [
        { title: 'Car Wash List', icon: 'tint', path: '/reports/washlist', badge: 0 },
        { title: 'Battery List', icon: 'battery-quarter', path: '/reports/batterylist', badge: 0 },
        { title: 'Applications', icon: 'user-plus', path: '/reports/applications', badge: 0 },
        { title: 'Accounts', icon: 'users', path: '/reports/accounts', badge: 0, finance: true },
        { title: 'Strata', icon: 'building', path: '/reports/strata', badge: 0, finance: true },
        { title: 'Council', icon: 'university', path: '/reports/council', badge: 0, finance: true }
        // { title: 'Retention', icon: 'external-link-square fa-rotate-90', path: '/reports/retention', badge: 0, finance: true },
        // { title: 'ANU Stripe Export', icon: 'download', path: '/reports/anu-export', badge: 0, finance: true }
      ],
      contracts: [
        { title: 'Contract Terms', icon: 'file-alt', path: '/contracts/terms', badge: 0 },
        { title: 'Organisations', icon: 'suitcase', path: '/contracts/organisations', badge: 0 },
        { title: 'Finance Codes', icon: 'university', path: '/contracts/finance-codes', badge: 0 }
      ],
      hardware: [
        { title: 'Boxes', icon: 'window-maximize', path: '/hardware/boxes', badge: 0 },
        { title: 'Sim Cards', icon: 'mobile', path: '/hardware/sim-cards', badge: 0 },
        { title: 'NPorts', icon: 'signal', path: '/hardware/nports', badge: 0 },
        { title: 'Petrol Cards', icon: 'credit-card', path: '/hardware/petrol-cards', badge: 0 }
      ],
      tickets: [
        { title: 'Outstanding', icon: 'ticket-alt', path: '/tickets/outstanding', badge: 0 },
        { title: 'Completed', icon: 'check-square', path: '/tickets/completed', badge: 0 }
      ]
    }
  },
  cards: {
    columns: [],
    permalink: false,
    rows: [],
    links: [],
    noResults: '',
    offset: 0,
    limit: 10,
    organizations: [],
    searchForm: {
      fields: []
    }
  },
  reservationSearch: {
    results: [],
    allCars: [],
    data: {
      rates: [],
      driver: '',
      start: '',
      end: ''
    },
    total: 0
  },
  smartcardActions: [
    { label: 'Delete', command: DELETE_SMARTCARD, icon: 'fa fa-trash-alt' },
    { label: 'Restore', command: RESTORE_SMARTCARD, icon: 'fa fa-undo' },
    { label: 'Unassign', command: UNASSIGN_SMARTCARD, icon: 'fa fa-ban' },
    { label: 'Assign', command: ASSIGN_SMARTCARD, icon: 'fa fa-user' }
  ],
  adminRequest: {
    request: {},
    data: {},
    backToBack: false
  },
  ticket: {
    labels: [],
    notes: []
  },
  contract: {
    type: '',
    kmUsage: {},
    Organization: {}
  },
  trailingRebatePromo: {
    Organization: {},
    PromoCode: {
      Accounts: []
    }
  },
  dashboardMessages: []
}

const mutations = {
  [OPEN_MODAL] (context, modal) {
    context.modals = [ ...context.modals, modal ]
  },
  [CLOSE_MODAL] (context, index) {
    if (index >= 0) {
      let modals = context.modals
      if (modals[index].redirect) {
        app.$router.push(modals[index].redirect, function () {}, function () {
          app.$router.push({
            path: modals[index].redirect + '?t=' + new Date().getTime()
          })
        })
      }
      modals.splice(index, 1)
      context.modals = modals
    } else {
      throw new Error('Could not find modal to remove')
    }
  },
  [CLOSE_FORM] (context, permalink) {
    let forms = context.forms
    let _forms = []
    for (let form of forms) {
      if (form.permalink !== permalink) {
        _forms.push(form)
      }
    }
    context.forms = _forms
  },
  [CLOSE_MODAL_FORM] (context, permalink) {
    let forms = []
    let modals = []
    for (let form of context.forms) {
      if (form.permalink !== permalink) {
        forms.push(form)
      }
    }
    for (let modal of context.modals) {
      if (modal.permalink !== permalink) {
        modals.push(modal)
      }
    }
    context.modals = modals
    context.forms = forms
  },
  [CLEAR_MODALS] (context) {
    context.modals = []
  },
  [LOAD_FORM] ({ forms }, form) {
    forms.push(form)
  },
  [LOAD_SIDEBAR] (context, counts) {
    let sidebar = { ...context.sidebar }
    sidebar.navigation.followUp.badge = counts.problemsCount + counts.notesCount + counts.repairCount
    sidebar.subNavigation.followUp[0].badge = counts.notesCount
    sidebar.subNavigation.followUp[1].badge = counts.problemsCount
    sidebar.subNavigation.followUp[2].badge = counts.repairCount
    sidebar.subNavigation.membership[0].badge = counts.applicationsCount
    sidebar.subNavigation.membership[1].badge = counts.activeMembers
    sidebar.navigation.tickets.badge = counts.issuesCount
    sidebar.navigation.membership.badge = counts.applicationsCount
    sidebar.notificationsCount = counts.notificationsCount
    context.sidebar = sidebar
  },
  [LOAD_NOTIFICATIONS_COUNT] (context, count) {
    context.sidebar = { ...context.sidebar, notificationsCount: count }
  },
  [CHANGE_NAVIGATION] (context, navId) {
    let sidebar = { ...context.sidebar }
    if (sidebar.subNavigation[navId]) {
      sidebar.currentSubNav = sidebar.subNavigation[navId]
      sidebar.currentSubKey = navId
    } else {
      sidebar.currentSubNav = []
    }
    context.sidebar = sidebar
  },
  [CLEAR_ADMIN_REQUEST] (state) {
    state.adminRequest = {}
  },
  [LOAD_ADMIN_REQUEST] (state, adminRequest) {
    state.adminRequest = adminRequest
  },
  [LOAD_DASHBOARD_MESSAGES] (state, dashboardMessages) {
    state.dashboardMessages = dashboardMessages
  },
  [LOAD_CONTRACT_DETAILS] (state, { contract, kmUsage }) {
    state.contract = contract
    state.contract.kmUsage = kmUsage
  },
  [LOAD_TRAILING_REBATE_PROMO_DETAILS] (state, { trailingRebatePromo }) {
    state.trailingRebatePromo = trailingRebatePromo
  },
  [LOAD_TICKET] (state, ticket) {
    state.ticket = ticket
  },
  [LOAD_DASHBOARD] (context, dashboard) {
    context.dashboard = dashboard
  },
  [LOAD_CARDS] (context, cards) {
    context.cards = cards
  },
  [LOGIN_USER] (context, account) {
    context.loggedInUser = account
  },
  [MODIFY_FORM_VALUE] (context, { permalink, name, value }) {
    let found = false
    let forms = [ ...context.forms ]
    for (let i in forms) {
      let form = forms[i]
      if (form.permalink === permalink) {
        found = i
      }
    }
    if (found) {
      for (let j in forms[found].sections) {
        let section = forms[found].sections[j]
        if (section.name === name) {
          forms[found].sections[j].value = value
        }
      }
      context.forms = [ ...forms ]
    }
  },
  [MODIFY_FORM_FIELD] (context, { permalink, name, field }) {
    let found = false
    let forms = [ ...context.forms ]
    for (let i in forms) {
      let form = forms[i]
      if (form.permalink === permalink) {
        found = i
      }
    }
    if (found) {
      for (let j in forms[found].sections) {
        let section = forms[found].sections[j]
        if (section.name === name) {
          forms[found].sections[j] = field
        }
      }
      context.forms = [ ...forms ]
    }
  },
  [LOAD_CAR_RESULTS] (context, cars) {
    context.reservationSearch = { ...context.reservationSearch, results: cars }
  },
  [LOAD_CAR_RESULTS_TOTAL] (context, count) {
    context.reservationSearch = { ...context.reservationSearch, total: count }
  },
  [LOAD_ALL_CAR_RESULTS] (context, cars) {
    context.reservationSearch = { ...context.reservationSearch, allCars: cars }
  },
  [LOAD_CAR_RESULTS_RATES] (context, data) {
    context.reservationSearch = { ...context.reservationSearch, data }
  },
  [EXPIRED_SESSION] (context, expiredSession) {
    context.expiredSession = expiredSession
  },
  [TOGGLE_SIDEBAR] (context) {
    context.sidebar = { ...context.sidebar, isOpen: !context.sidebar.isOpen }
  },
  [LOAD_ORGANIZATION] (context, organization) {
    context.organization = { ...context.organization, ...organization }
  }
}

const actions = {
  async [DELETE_VALET] (context, valetId) {
    await api.deleteValet(valetId)
  },
  async [TECH_PUSH_VALET] (context, valetId) {
    await api.techPushValet(valetId)
  },
  async [LOAD_ADMIN_REQUEST] (context, problemId) {
    let adminRequest = await api.getAdminRequest(problemId)
    context.commit(LOAD_ADMIN_REQUEST, adminRequest)
  },
  async [LOAD_DASHBOARD_MESSAGES] (context, OrganizationUuid) {
    let dashboardMessages = await api.getDashboardMessages({ OrganizationUuid })
    context.commit(LOAD_DASHBOARD_MESSAGES, dashboardMessages)
  },
  async [LOAD_TICKET] (context, ticketId) {
    let ticket = await api.getTicket(ticketId)
    context.commit(LOAD_TICKET, ticket)
  },
  async [CLOSE_TICKET] (context, ticketId) {
    await api.closeTicket(ticketId)
  },
  async [REOPEN_TICKET] (context, ticketId) {
    await api.reopenTicket(ticketId)
  },
  async [DELETE_TICKET] (context, ticketId) {
    await api.deleteTicket(ticketId)
  },
  async [ADD_TICKET_PRIORITY] (context, ticketId) {
    await api.addTicketPriority(ticketId)
  },
  async [REMOVE_TICKET_PRIORITY] (context, ticketId) {
    await api.removeTicketPriority(ticketId)
  },
  async [CLOSE_LOT] (context, lot) {
    let data = await api.closeLot(lot.uuid)
    return data
  },
  async [OPEN_LOT] (context, lot) {
    let data = await api.openLot(lot.uuid)
    return data
  },
  async [TOGGLE_LOT_OVERNIGHT] (context, lot) {
    let data = await api.toggleLotOvernight(lot.uuid)
    return data
  },
  async [TOGGLE_LOT_WEEKEND] (context, lot) {
    let data = await api.toggleLotWeekend(lot.uuid)
    return data
  },
  async [TOGGLE_LOT_ONE_WAY_TRIPS] (context, lot) {
    let data = await api.toggleLotOneWayTrips(lot.uuid)
    return data
  },
  [DELETE_ACCOUNT_MESSAGE] (context, message) {
    let deleteAccountMessageModal = {
      permalink: 'deleteAccountMessage',
      options: {
        title: 'Delete Account Message',
        actionLabel: 'Delete'
      },
      params: {
        AccountMessageUuid: message.uuid
      }
    }
    context.dispatch(OPEN_MODAL, deleteAccountMessageModal)
  },
  [DELETE_DASHBOARD_MESSAGE] (context, message) {
    let deleteDashboardMessageModal = {
      permalink: 'deleteDashboardMessage',
      options: {
        title: 'Delete Dashboard Message',
        actionLabel: 'Delete'
      },
      params: {
        DashboardMessageUuid: message.uuid
      }
    }
    context.dispatch(OPEN_MODAL, deleteDashboardMessageModal)
  },
  [DELETE_CAR_RESTRICTION] (context, restriction) {
    let deleteCarRestrictionModal = {
      permalink: 'deleteCarRestriction',
      options: {
        title: 'Delete Car Restriction',
        actionLabel: 'Delete'
      },
      params: {
        CarRestrictionUuid: restriction.uuid
      }
    }
    context.dispatch(OPEN_MODAL, deleteCarRestrictionModal)
  },
  [ASSIGN_SMARTCARD] (context, card) {
    let assignSmartCardModal = {
      permalink: 'assignSmartcard',
      options: {
        title: 'Assign Smartcard',
        actionLabel: 'Assign'
      },
      params: {
        SmartcardUuid: card.uuid
      }
    }
    context.dispatch(OPEN_MODAL, assignSmartCardModal)
  },
  [REPAIR_DAMAGE] (context, damageUuid) {
    let repairDamageModal = {
      permalink: 'repairDamage',
      options: {
        title: 'Repair Damage',
        actionLabel: 'Save'
      },
      params: {
        DamageUuid: damageUuid
      }
    }
    context.dispatch(OPEN_MODAL, repairDamageModal)
  },
  [COMPLETE_LOT_RELOCATION] (context, lotRelocation) {
    let completeLotRelocationModal = {
      permalink: 'completeLotRelocation',
      options: {
        title: 'Complete Lot Relocation',
        actionLabel: 'Save'
      },
      params: {
        LotRelocationUuid: lotRelocation.uuid
      }
    }
    context.dispatch(OPEN_MODAL, completeLotRelocationModal)
  },
  [CANCEL_LOT_RELOCATION] (context, lotRelocation) {
    let cancelLotRelocationModal = {
      permalink: 'cancelLotRelocation',
      options: {
        title: 'Cancel Lot Relocation',
        actionLabel: 'Save'
      },
      params: {
        LotRelocationUuid: lotRelocation.uuid
      }
    }
    context.dispatch(OPEN_MODAL, cancelLotRelocationModal)
  },
  [DELETE_SMARTCARD] (context, card) {
    let deleteSmartCardModal = {
      permalink: 'deleteSmartcard',
      options: {
        title: 'Delete Smartcard',
        actionLabel: 'Delete'
      },
      params: {
        SmartcardUuid: card.uuid
      }
    }
    context.dispatch(OPEN_MODAL, deleteSmartCardModal)
  },
  [RESTORE_SMARTCARD] (context, card) {
    let deleteSmartCardModal = {
      permalink: 'restoreSmartcard',
      options: {
        title: 'Restore Smartcard',
        actionLabel: 'Restore'
      },
      params: {
        SmartcardUuid: card.uuid
      }
    }
    context.dispatch(OPEN_MODAL, deleteSmartCardModal)
  },
  async [OPEN_MODAL] (context, modal) {
    context.commit(OPEN_MODAL, modal)
  },
  async [OPEN_ERROR_MODAL] (context, error) {
    context.commit(CLEAR_MODALS)
    let errorMessage = error.data || error.message
    let errorModal = {
      title: 'Error Processing Request',
      html: '<p class="alert alert-danger">' + errorMessage + '</p>'
    }
    context.dispatch(OPEN_MODAL, errorModal)
  },
  async [OPEN_CONFIRMATION_MODAL] (context, payload) {
    context.commit(CLEAR_MODALS)
    if (payload.redirect) {
      context.commit(CLOSE_FORM, payload.permalink)
    }
    let confirmationModal = {
      title: 'Success',
      html: '<p>' + payload.confirmation + '</p>',
      redirect: payload.redirect || false
    }
    context.dispatch(OPEN_MODAL, confirmationModal)
  },
  async [OPEN_NOTIFICATION_MODAL] (context, notification) {
    let notificationModal = {
      alertUuid: notification.uuid,
      data: {
        title: notification.name,
        html: notification.message,
        createdAt: notification.createdAt
      }
    }
    context.dispatch(OPEN_MODAL, notificationModal)
  },
  async [LOAD_FORM] (context, opts) {
    try {
      let form = await api.getForm(opts.permalink, opts.params, opts.auth)
      context.commit(LOAD_FORM, form)
    } catch (err) {
      throw err
    }
  },
  async [REFRESH_LOGGED_IN_USER] (context) {
    try {
      let account = await api.refreshLoggedInUser()
      context.commit(LOGIN_USER, account.object)
    } catch (e) {
      throw new Error('Could not refresh your session')
    }
  },
  async [SUBMIT_FORM] (context, opts) {
    let response = {}
    try {
      response = await api.submitForm(opts.data, opts.method, opts.auth)
    } catch (err) {
      throw err
    }
    switch (opts.data.permalink) {
      case 'adminLogin':
        context.dispatch(LOGIN, response.token)
        context.commit(LOGIN_USER, response.account)
        context.commit(EXPIRED_SESSION, false)
        break
      case 'editCreditCardNickname':
      case 'deleteCreditCard':
        context.commit(MODIFY_FORM_VALUE, {
          permalink: 'editAccount',
          name: 'creditCard',
          value: response.cards
        })
        context.commit(LOAD_USER_CREDIT_CARDS, response.cards)
        if (response.notes) {
          context.commit(LOAD_USER_NOTES, response.notes.rows)
          context.commit(LOAD_USER_NOTES_TOTAL, response.notes.count)
        }
        break
      case 'getCarMessages':
        context.commit(LOAD_CAR_MESSAGES, response.messages.rows)
        context.commit(LOAD_CAR_MESSAGES_TOTAL, response.messages.count)
        context.commit(LOAD_CAR_MESSAGES_TYPE, response.type)
        break
      case 'getReservationNotes':
        context.commit(LOAD_RESERVATION_NOTES, response.notes.rows)
        context.commit(LOAD_RESERVATION_NOTES_TOTAL, response.notes.count)
        break
      case 'getUserReservations':
        context.commit(LOAD_USER_RESERVATIONS_COLUMNS, response.reservations.columns)
        context.commit(LOAD_USER_RESERVATIONS, response.reservations.rows)
        context.commit(LOAD_USER_RESERVATIONS_TOTAL, response.reservations.count)
        break
      case 'getUserDrivers':
        context.commit(LOAD_USER_DRIVERS, response.rows)
        context.commit(LOAD_USER_DRIVERS_COLUMNS, response.columns)
        context.commit(LOAD_USER_DRIVERS_TOTAL, response.count)
        break
      case 'getUserFiles':
        context.commit(LOAD_USER_FILES, response.files.rows)
        context.commit(LOAD_USER_FILES_TOTAL, response.files.count)
        context.commit(LOAD_USER_FILES_COLUMNS, response.files.columns)
        break
      case 'getUserNotes':
        context.commit(LOAD_USER_NOTES, response.notes.rows)
        context.commit(LOAD_USER_NOTES_TOTAL, response.notes.count)
        break
      case 'getCarReservations':
        context.commit(LOAD_CAR_RESERVATIONS, response.reservations.rows)
        context.commit(LOAD_CAR_RESERVATIONS_TOTAL, response.reservations.count)
        context.commit(LOAD_CAR_RESERVATIONS_COLUMNS, response.reservations.columns)
        break
      case 'getLedger':
        context.commit(LOAD_USER_LEDGER, response.rows)
        context.commit(LOAD_USER_LEDGER_COLUMNS, response.columns)
        break
      case 'getCarNotes':
        context.commit(LOAD_CAR_NOTES, response.notes.rows)
        context.commit(LOAD_CAR_NOTES_TOTAL, response.notes.count)
        break
      case 'getCarDamages':
        context.commit(LOAD_CAR_DAMAGES, response.damages.rows)
        context.commit(LOAD_CAR_DAMAGES_TOTAL, response.damages.count)
        break
      case 'newReservation':
        context.dispatch(OPEN_CONFIRMATION_MODAL, {
          confirmation: `<div class="car-details clearfix">
            <div class="text-centre">
              <p><strong>Your booking has been confirmed!</strong></p>
              <img src="https://techcar-dev.s3.amazonaws.com/${response.Car.CarType.AmazonImage.objectKey}"/>
              <p>
                <strong>${response.Car.CarType.name} (#${response.Car.convadisId} - ${response.Car.name})</strong>
              </p>
              <p>
                <span class="fa fa-map-marker-alt fa-fw"></span>
                ${response.Lot.address}
              </p>
              <p><strong>Booking #${response.reservationId}</strong> confirmed for <strong>${response.Account.dropdownLabel}</strong></p>
            </div>
          </div>`,
          redirect: `/fleet/reservations/${response.uuid}`
        })
        break
      case 'cancelReservation':
        context.dispatch(OPEN_CONFIRMATION_MODAL, {
          confirmation: response.message,
          redirect: `/fleet/reservations/${response.reservation.uuid}`
        })
        break
      case 'searchReservation':
        context.commit(LOAD_CAR_RESULTS, response.cars)
        context.commit(LOAD_CAR_RESULTS_TOTAL, response.count)
        context.commit(LOAD_ALL_CAR_RESULTS, response.allCars)
        context.commit(LOAD_CAR_RESULTS_RATES, response.data)
        break
      case 'refundPendingCharge':
      case 'createPendingCharge':
      case 'captureHeldCharge':
      case 'releaseHeldCharge':
        context.commit(LOAD_HELD_CHARGE, response)
        break
      case 'addSmartcard':
      case 'unassignSmartcard':
        context.commit(LOAD_SMART_CARD, response.smartcard)
        if (response.AccountNotes) {
          context.commit(LOAD_USER_NOTES, response.AccountNotes)
        }
        break
      case 'addPetrolCard':
        context.commit(LOAD_PETROL_CARDS, response)
        break
      case 'cancelPetrolCard':
        context.commit(LOAD_PETROL_CARDS, response.petrolCards)
        context.commit(LOAD_CAR_NOTES, response.notes.rows)
        context.commit(LOAD_CAR_NOTES_TOTAL, response.notes.count)
        break
    }
    // context.commit(SUBMIT_FORM, response)
  },
  async [RESOLVE_NOTE] (context, noteId) {
    return await api.resolveNote(noteId)
  },
  async [RESOLVE_DAMAGE] (context, damageId) {
    return await api.resolveDamage(damageId)
  },
  async [LOAD_SIDEBAR] (context) {
    let counts = await api.getSidebar()
    context.commit(LOAD_SIDEBAR, counts)
    context.commit(LOAD_NOTIFICATIONS, counts.notifications)
  },
  async [LOAD_DASHBOARD] (context, payload) {
    let dashboard = await api.getDashboard(payload)
    context.commit(LOAD_DASHBOARD, dashboard)
  },
  async [LOAD_CONTRACT_DETAILS] (context, contractId) {
    let { contract, kmUsage } = await api.getContract(contractId)
    context.commit(LOAD_CONTRACT_DETAILS, { contract, kmUsage })
  },
  async [LOAD_TRAILING_REBATE_PROMO_DETAILS] (context, trailingRebatePromoId) {
    let { trailingRebatePromo } = await api.getTrailingRebatePromo(trailingRebatePromoId)
    context.commit(LOAD_TRAILING_REBATE_PROMO_DETAILS, { trailingRebatePromo })
  },
  [CHANGE_NAVIGATION] (context, navId) {
    context.commit(CHANGE_NAVIGATION, navId)
  },
  async [LOAD_CARDS] (context, options) {
    let cards = await api.getCards(options)
    context.commit(LOAD_CARDS, cards)
  },
  async [LOAD_ORGANIZATION] (context, domain) {
    let organization = await api.loadOrganization(domain)
    context.commit(LOAD_ORGANIZATION, organization)
  },
  [TOGGLE_SIDEBAR] (context) {
    context.commit(TOGGLE_SIDEBAR)
  }
}

const getters = {
  adminRequest ({ adminRequest }) {
    return adminRequest
  },
  ticket ({ ticket }) {
    return ticket
  },
  smartcardActions: ({ smartcardActions }) => (card, admin) => {
    let excludeActions = []
    if (card.deletedAt) {
      excludeActions.push(DELETE_SMARTCARD)
    } else {
      excludeActions.push(RESTORE_SMARTCARD)
    }
    if (card.AccountUuid) {
      excludeActions.push(ASSIGN_SMARTCARD)
    } else {
      excludeActions.push(UNASSIGN_SMARTCARD)
    }
    return smartcardActions.filter(el => !excludeActions.includes(el.command))
  },
  modals ({ modals }) {
    return modals
  },
  getActiveModal ({ modals }) {
    return modals.length ? modals[modals.length - 1] : false
  },
  forms ({ forms }) {
    return forms
  },
  getForm: ({ forms }) => (permalink) => {
    return forms.find(f => f.permalink === permalink)
  },
  [GET_FORM_VALUE]: ({ forms }) => ({ permalink, name }) => {
    let found = false
    for (let i in forms) {
      let form = forms[i]
      if (form.permalink === permalink) {
        found = i
      }
    }
    if (found) {
      for (let j in forms[found].sections) {
        let section = forms[found].sections[j]
        if (section.name === name) {
          return forms[found].sections[j].value
        }
      }
    }
    return false
  },
  [GET_FORM_FIELD]: ({ forms }) => ({ permalink, name }) => {
    let found = false
    for (let i in forms) {
      let form = forms[i]
      if (form.permalink === permalink) {
        found = i
      }
    }
    if (found) {
      for (let j in forms[found].sections) {
        let section = forms[found].sections[j]
        if (section.name === name) {
          return forms[found].sections[j]
        }
      }
    }
    return false
  },
  loggedInUser ({ loggedInUser }) {
    return loggedInUser
  },
  isFinanceAdmin ({ loggedInUser }) {
    return loggedInUser.AccountType ? loggedInUser.AccountType.financeAdministrator : false
  },
  navigation: ({ sidebar }) => (admin) => {
    let mainNav = Object.assign({}, sidebar.navigation)
    if (!admin.AccountType || !admin.AccountType.financeAdministrator) {
      for (let nav in mainNav) {
        if (mainNav[nav].finance) {
          delete mainNav[nav]
        }
      }
    }
    return mainNav
  },
  currentSubNav: ({ sidebar }) => (admin) => {
    if (!admin.AccountType || !admin.AccountType.financeAdministrator) {
      return sidebar.currentSubNav.filter(el => !el.finance)
    } else {
      return sidebar.currentSubNav
    }
  },
  currentSubKey ({ sidebar }) {
    return sidebar.currentSubKey
  },
  contract ({ contract }) {
    return contract
  },
  trailingRebatePromo ({ trailingRebatePromo }) {
    return trailingRebatePromo
  },
  notificationsCount ({ sidebar }) {
    return sidebar.notificationsCount
  },
  dashboard ({ dashboard }) {
    return dashboard
  },
  cards ({ cards }) {
    return cards
  },
  reservationSearchResults ({ reservationSearch }) {
    return reservationSearch.results
  },
  reservationSearchResultsTotal ({ reservationSearch }) {
    return reservationSearch.total
  },
  reservationSearchResultsAll ({ reservationSearch }) {
    return reservationSearch.allCars
  },
  reservationSearchRates ({ reservationSearch }) {
    return reservationSearch.data
  },
  cardsSearchForm ({ cards }) {
    return cards.searchForm.fields.concat([
      { name: 'limit', label: 'Limit per page', fullWidth: true, type: 'search', value: cards.limit }
    ])
  },
  expiredSession ({ expiredSession }) {
    return expiredSession
  },
  sideBarOpen ({ sidebar }) {
    return sidebar.isOpen
  },
  organization ({ organization }) {
    return organization
  },
  dashboardMessages ({ dashboardMessages }) {
    return dashboardMessages
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/application.js